module.exports = __webpack_public_path__ + "static/project-8b-e1b902d22dfc4caafa40b94bf981424d.png";